export default __webpack_public_path__ + "static/media/higher_icon_network_.5d41a4a5.svg";